import { zodResolver } from '@hookform/resolvers/zod';
import { type SubmitHandler, useForm } from 'react-hook-form';
import { z } from 'zod';

import Button from '@/components/BaseLibrary/Button/Button';
import FormInput, {
  InputType,
} from '@/components/BaseLibrary/FormInput/FormInput';
import useStyles from '@/components/InteractiveQuoteForm/InteractiveQuoteForm.styles';
import { trackEvents } from '@/utils/analytics';
import { emailValidator, InputName } from '@/utils/validation/inputs';

interface EmailStepProps {
  handleNext: (data: SchemaType) => void;
}

const schema = z.object({
  ...emailValidator,
});
type SchemaType = z.infer<typeof schema>;

export default function EmailStep({ handleNext }: EmailStepProps) {
  const { classes } = useStyles();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<SchemaType>({
    resolver: zodResolver(schema),
    mode: 'onTouched',
  });

  const onSubmit: SubmitHandler<SchemaType> = (data: SchemaType) => {
    trackEvents({
      event: 'Form_cta_click',
      Form_tab: 'Email Address',
      Form_step: 4,
      click_text: 'Next',
    });
    handleNext(data);
  };

  return (
    <>
      <FormInput
        placeholder='Enter your Email Address'
        name={InputName.EMAIL}
        testId='email-input'
        type={InputType.TEXT}
        inputMode='email'
        error={errors[InputName.EMAIL]?.message}
        register={register}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSubmit(onSubmit);
          }
        }}
      />
      <div className={classes.buttonContainer}>
        <Button
          onClick={handleSubmit(onSubmit)}
          label='Next'
          disabled={!isValid}
          className={classes.button}
        />
      </div>
    </>
  );
}
